import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export class SelloViewsItem {
	viewId: string;
}

class SelloViewsItemDTO {
	viewId: string;
}

type SelloViewsResponse = {
	data: {
		item: SelloViewsItemDTO,
	}
}

export class SelloViewsQuery extends Query<SelloViewsItem> {
    public constructor(public readonly params: {
        readonly viewContextName: any;
    }) {
        super();
    }
}

export class SelloViewsQueryHandlerBase implements QueryHandler<SelloViewsQuery, SelloViewsItem> {
	private static Url = TaggedUrl.join('views', [Tags.SelloApi]);

	public constructor(
		private readonly http: HttpService,
	) { }

	public async handleAsync(query: SelloViewsQuery): Promise<SelloViewsItem> {
		const response = await this.http.get<SelloViewsResponse>(SelloViewsQueryHandlerBase.Url, {
			params: { ...query.params },
		});
		return response.data.data.item;
	}
}
